import type { OnInit } from '@angular/core';
import { Component } from '@angular/core';

import type { FieldTypeConfig } from '@ngx-formly/core';
import { FieldType } from '@ngx-formly/core';

import type { InputType } from '@valk-nx/components/ui-input/src/lib/input';

@Component({
	selector: 'formly-field-input',
	template: `
		<vp-input
			[className]="props['className']"
			[disabled]="props.disabled"
			[forceInitialValue]="props['forceInitialValue'] || false"
			[formControl]="formControl"
			[hasError]="showError"
			[icon]="props['icon']"
			[iconPosition]="props['iconPosition']"
			[initialValue]="formControl.value"
			[inputId]="field.id"
			[isLoading]="props['isLoading']"
			[isOptional]="props['optional']"
			[isValid]="formControl.valid"
			[maskOptions]="props['maskOptions']"
			[name]="field.id"
			[placeholder]="props.placeholder"
			[readonly]="props.readonly"
			[type]="inputType"
			ngDefaultControl
		/>
	`,
	standalone: false,
})
export class InputComponent
	extends FieldType<FieldTypeConfig>
	implements OnInit
{
	inputType: InputType;

	ngOnInit(): void {
		this.inputType = this.field.type as InputType;
	}
}
